import { LoanCrud } from "./loanCrud";

export default function NewLoan(){
    return <LoanCrud name="签单客户" type="new" router="newLoans" />
}